import { render, staticRenderFns } from "./OffCardRoomState.vue?vue&type=template&id=9a0ee1ba&scoped=true"
import script from "./OffCardRoomState.vue?vue&type=script&lang=js"
export * from "./OffCardRoomState.vue?vue&type=script&lang=js"
import style0 from "./OffCardRoomState.vue?vue&type=style&index=0&id=9a0ee1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0ee1ba",
  null
  
)

export default component.exports